<template>
  <div>
    <Collapse v-model="value" simple style="border:0">
      <Panel name="1" hide-arrow style="margin: 20px 0;border:0">
        <FormTitle :titleText="$t('longText21')" /><!-- 绩效改进进度回顾 -->
        <div slot="content" style="margin-top: 20px;">
          <div style="margin-bottom:20px">
            <!-- 协商并确认回顾日期，跟进员工绩效改进的进度 -->{{
              $t("longText22")
            }}
          </div>
          <Table border :columns="columns5" :data="data5">
            <template
              slot-scope="{ row, index }"
              slot="reviewDate"
              style="width:100%"
            >
              <DatePicker
                type="date"
                v-model="row.reviewDate"
                :transfer="true"
                :disabled="
                  isDirSup == '3' ||
                    isDirSup == '2' ||
                    (isDirSup == '1' && item.status >= '3') ||
                    item.status == 1
                "
                @on-change="targetItemChange(row, index, 'reviewDate')"
              />
            </template>
            <template slot-scope="{ row, index }" slot="action">
              <Input
                type="textarea"
                v-model="row.action"
                :autosize="true"
                :disabled="
                  isDirSup == '3' ||
                    isDirSup == '2' ||
                    (isDirSup == '1' && item.status >= '3') ||
                    item.status == 1
                "
                @on-change="targetItemChange(row, index, 'action')"
              />
            </template>
            <template
              slot-scope="{ row, index }"
              slot="finishDate"
              style="width:100%"
            >
              <DatePicker
                type="date"
                v-model="row.finishDate"
                :transfer="true"
                :disabled="
                  isDirSup == '3' ||
                    isDirSup == '2' ||
                    (isDirSup == '1' && item.status >= '3') ||
                    item.status == 1
                "
                @on-change="targetItemChange(row, index, 'finishDate')"
              />
            </template>
            <template
              slot-scope="{ row, index }"
              slot="dutyUser"
              style="width:100%"
            >
              <Input
                type="textarea"
                v-model="row.dutyUser"
                :autosize="true"
                :disabled="
                  isDirSup == '3' ||
                    isDirSup == '2' ||
                    (isDirSup == '1' && item.status >= '3') ||
                    item.status == 1
                "
                @on-change="targetItemChange(row, index, 'dutyUser')"
              />
            </template>
            <template slot-scope="{ row, index }" slot="measureFun">
              <Input
                type="textarea"
                v-model="row.measureFun"
                :autosize="true"
                :disabled="
                  isDirSup == '3' ||
                    isDirSup == '2' ||
                    (isDirSup == '1' && item.status >= '3') ||
                    item.status == 1
                "
                @on-change="targetItemChange(row, index, 'measureFun')"
              />
            </template>
            <template slot-scope="{ row, index }" slot="actionProgressMsg">
              <Input
                type="textarea"
                v-model="row.actionProgressMsg"
                :autosize="true"
                :disabled="
                  isDirSup == '3' ||
                    isDirSup == '2' ||
                    (isDirSup == '1' && item.status >= '3') ||
                    item.status == 1
                "
                @on-change="targetItemChange(row, index, 'actionProgressMsg')"
              />
            </template>
            <template slot-scope="{ row, index }" slot="actionProgressEmp">
              <Input
                type="textarea"
                v-model="row.actionProgressEmp"
                :autosize="true"
                :disabled="
                  isDirSup == '1' ||
                    isDirSup == '3' ||
                    (isDirSup == '2' && item.status != '3')
                "
                @on-change="targetItemChange(row, index, 'actionProgressEmp')"
              />
            </template>
            <template slot-scope="{ row, index }" slot="action5">
              <Button
                icon="md-trash"
                type="warning"
                size="small"
                :disabled="
                  isDirSup == '3' ||
                    isDirSup == '2' ||
                    (isDirSup == '1' && item.status >= '3') ||
                    item.status == 1
                "
                @click="deletePlan(index, row)"
              ></Button>
            </template>
          </Table>
          <div
            style="display: flex; justify-content: flex-end; margin-top:10px;margin-bottom:30px"
          >
            <Button
              @click="addPlan()"
              :disabled="
                isDirSup == '3' ||
                  isDirSup == '2' ||
                  (isDirSup == '1' && item.status >= '3') ||
                  item.status == 1
              "
              ><!-- 新增 -->{{ $t("Add") }}</Button
            >
          </div>
          <Alert type="error"> {{ $t("longText51") }}</Alert>
        </div>
      </Panel>
      <Panel name="2" hide-arrow style="margin-bottom: 20px;border:0">
        <FormTitle :titleText="$t('Conclusion')" /><!-- 结论 -->
        <div style="margin-top: 30px" slot="content">
          <div>
            <!-- 根据员工在评估期间的表现做出结论 -->{{ $t("longText26") }}
          </div>
          <div style="margin:20px 0">
            <!-- 经理评估 -->{{ $t("Manager_Comments_Word") }}
          </div>
          <Input
            v-model="formItem.managerAssess"
            :disabled="
              isDirSup == '3' ||
                isDirSup == '2' ||
                (isDirSup == '1' && item.status >= '3') ||
                item.status == 1
            "
            type="textarea"
            :rows="4"
          />
          <div style="margin:30px 0">
            <span><!-- 结论 -->{{ $t("Conclusion") }}：</span>
            <Select
              v-model="formItem.conclusion"
              style="width:260px"
              :disabled="
                isDirSup == '3' ||
                  isDirSup == '2' ||
                  (isDirSup == '1' && item.status >= '3') ||
                  item.status == 1
              "
            >
              <Option
                v-for="item in Conclusion"
                :value="item.ch_value"
                :key="item.code"
                >{{ lang == "zh" ? item.ch_value : item.en_value }}</Option
              >
            </Select>
          </div>
          <Alert type="error">{{ $t("longText51") }}</Alert>

          <Checkbox
            style="margin-top:30px"
            :disabled="
              isDirSup != '2' ||
                (isDirSup == '2' && item.status == 2) ||
                item.status == '4'
            "
            v-model="formItem.returnAgreeOn"
            ><span style="font-weight:bold">{{
              $t("longText52")
            }}</span></Checkbox
          >
        </div>
      </Panel>
    </Collapse>
    <div class="btnRight" style="padding-top:0px">
      <Button
        type="primary"
        class="applyBtnRight"
        v-if="
          (isDirSup == '1' && item.status == '2') ||
            (isDirSup == '2' && item.status == '3')
        "
        @click="submit"
        ><!-- 提交 -->{{ $t("Submit") }}</Button
      >
      <Button type="primary" class="applyBtnRight" @click="returnApply"
        ><!-- 返回 -->{{ $t("Return") }}</Button
      >
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      value: [1, 2],
      formItem: {},
      list: [{ value: 0, label: "name1" }],
      textareaValue2: "",
      single: "",
      data5: [],
      isDirSup: "",
      id: "",
      item: {},
      Conclusion: []
    };
  },
  computed: {
    lang() {
      return this.$store.getters.selectLangeData;
    },
    columns5() {
      return [
        {
          title: this.$t("Review_Date") /* 回顾时间 */,
          slot: "reviewDate",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Actions") /* 行动 */,
          slot: "action",
          align: "center",
          minWidth: 300
        },
        {
          title: this.$t("Deadlines") /* 完成时间 */,
          slot: "finishDate",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Responsibles") /* 责任人 */,
          slot: "dutyUser",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Measurement") /* 衡量方法 */,
          slot: "measureFun",
          align: "center",
          minWidth: 300
        },
        {
          title: this.$t("Progress_Manager_") /* 行动进展（经理） */,
          slot: "actionProgressMsg",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Progress_Employee_") /* 行动进展（员工） */,
          slot: "actionProgressEmp",
          align: "center",
          minWidth: 120
        },
        {
          title: this.$t("Action") /* 操作 */,
          slot: "action5",
          align: "center",
          minWidth: 100
        }
      ];
    }
  },
  mounted() {
    this.getListData();
  },
  methods: {
    getListData() {
      axios.post("/achReport/selectAchReportLabelInfo", {}).then(res => {
        if (res) {
          this.Conclusion = res.Conclusion;
        }
      });
    },
    getData(item) {
      this.item = item;
      let obj = {
        id: this.id,
        stage: "进度回顾",
        serialnumber: item.serialnumber,
        year: item.year
      };
      axios.post("/achUpdatePlan/selectAchUpdatePlanInfo", obj).then(res => {
        if (res) {
          res.achRaiseActionList ? (this.data5 = res.achRaiseActionList) : "";
          this.formItem = res;
          this.formItem.returnAgreeOn = !!+this.formItem.returnAgreeOn;
          this.item = this.formItem;
        }
      });
    },
    deletePlan(index, row) {
      this.$Modal.confirm({
        title: this.$t("Are_you_sure_to_delete"),
        onOk: () => {
          this.data5.splice(index, 1);
        }
      });
    },
    addPlan() {
      this.data5.push({
        reviewDate: "",
        action: "",
        dinishDate: "",
        dutyUser: "",
        measureFun: "",
        actionProgressMsg: "",
        actionProgressEmp: ""
      });
    },
    targetItemChange(row, index, key) {
      key && this.$set(this.data5[index], key, row[`${key}`]);
    },
    submit() {
      if (
        this.empCheck() &&
        (this.formItem.returnAgreeOn == "" || !this.formItem.returnAgreeOn)
      ) {
        this.$Message.info(
          this.$t(
            "请勾选本人与直线经理就我的工作表现进行了讨论并制定了上述的行动计划，双方已达成共识。"
          )
        );
        return;
      }
      if (
        this.dirCheck() &&
        (!this.formItem.managerAssess || this.formItem.managerAssess == "")
      ) {
        this.$Message.info(this.$t("请填写经理评估"));
        return;
      }
      if (
        this.dirCheck() &&
        (!this.formItem.conclusion || this.formItem.conclusion == "")
      ) {
        this.$Message.info(this.$t("请选择结论"));
        return;
      }
      let json = JSON.parse(JSON.stringify(this.formItem));
      json.returnAgreeOn
        ? (json.returnAgreeOn = "1")
        : (json.returnAgreeOn = "0");
      this.$Modal.confirm({
        title: this.$t("Please_confirm_whether_to_submit"),
        onOk: () => {
          let obj = {
            id: this.id,
            stage: "进度回顾",
            achRaiseActionList: this.data5,
            ...json
          };
          axios
            .post("/achUpdatePlan/insertAchUpdatePlanInfo", obj)
            .then(res => {
              this.$Message.success(this.$t("sbumit_Success"));
              this.getData(this.item);
            });
        }
      });
    },
    returnApply() {
      if (this.$route.query.toPage == "staffview") {
        this.$router.back();
      } else {
        this.$router.push({
          path:
            "/A8E9DCF043CE767F05D716BD894E6E2DA1F5FE9AF7628B41/A3FFBEBFDB713E27",
          query: { name: "PerformanceCoaching" }
        });
      }
    },
    empCheck() {
      if (
        this.isDirSup != "2" ||
        (this.isDirSup == "2" && this.item.status == 2) ||
        this.item.status == "4"
      ) {
        return false;
      } else {
        return true;
      }
    },
    dirCheck() {
      if (
        this.isDirSup == "2" ||
        this.isDirSup == "3" ||
        this.item.status != 2
      ) {
        return false;
      } else {
        return true;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.panelTit {
  margin-top: 30px;
}
/deep/.ivu-divider-horizontal {
  margin: 10px 0 24px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/MyAchievementsComponents/ProgressReview.vue